
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import DivSpan from '@/components/DivSpan';
import {listSort} from "../../../utils/commons";

export default {
directives: {
TransferDom
},
components: {
Grid,
GridItem,
DivSpan,
Popup,
PopupHeader
},
data() {
return {
view: false,
cargoId: null,
cargoItemDto: {},
data: [],
show: false,
startShow: false,
endShow: false,
pauseShow: false,
beginShow: false,
finishShow: false,
supplierEnrollDto: {},
operationBol: false,//操作弹窗
approvalText: "",
operationList: [],
userType: null,
state: "",
offerRoundBol: false,
offerRoundList: [],
bidAssessBol: false,//评标
bidAssessList: [],
sourceStatus: {
NEW: {name: '新建/立项', linkName: ''},
FINISH: {name: '结束', linkName: ''},
SUSPEND: {name: '中止', linkName: ''},
ENROLL: {name: '报名/资格预审', linkName: '待我审核的供应商'},
OFFER: {name: '报价/投标', linkName: '报价/投标'},
RATING: {name: '评比/评标', linkName: '评比/评标'},
AWARD: {name: '定价/决标', linkName: ''},
},
currentStageStatus: {},
requireGoodsOrderDtsData: [],//待确认计划
}
},

methods: {
indexOf(str, par) {
if (!str) {
str = '';
}
return str.indexOf(par) != -1;
},
showMore() {
this.show = true;
},

getSourceDetail() {
this.$loadingShow();
this.$get('api/requireGoodsOrder/' + this.cargoId).then((data) => {
this.cargoItemDto = data;

this.operationList = [];
this.state = this.cargoItemDto.state;
this.cargoItemDto.requireGoodsOrderDts.forEach(item => {
if (item.status == 'unConfirm') {
this.view = true;
}
})
if (this.cargoItemDto.status !== 'SUSPEND' && this.cargoItemDto.status !== 'FINISH') {
if (this.cargoItemDto.currentStage && (this.cargoItemDto.currentStage.type === 'ENROLL' || this.cargoItemDto.currentStage.type === 'OFFER') && this.cargoItemDto.currentStage.status !== 'PAUSE') {
let item;
if (this.cargoItemDto.currentStage && this.cargoItemDto.currentStage.status === 'NOT_STARTED') {
item = {
key: 'begin',
label: '开始本阶段'
}
} else {
item = {
key: 'end',
label: '结束本阶段'
};
}
this.operationList.push(item);
}
if (this.cargoItemDto.currentStage && this.cargoItemDto.currentStage.status !== 'PAUSE') {
let item = {
key: 'paused',
label: '暂停当前阶段'
};
this.operationList.push(item);
}
if (this.cargoItemDto.currentStage && this.cargoItemDto.currentStage.status === 'PAUSE') {
let item = {
key: 'continue',
label: '继续当前阶段'
};
this.operationList.push(item);
}




this.operationList.push(item);
}
;

if (this.cargoItemDto.stages) {
this.bidAssessList = [];
this.offerRoundList = [];
this.cargoItemDto.stages.forEach((item) => {
if (item.type === 'OFFER') {
item.label = '第' + item.round + '轮报价';
if (item.status === 'GOING') {
item.label = item.label + '(进行中)';
item.type = 'primary';
} else if (item.status === 'NOT_STARTED') {
item.label = item.label + '(未开始)';
item.type = 'disabled';
} else if (item.status === 'FINISH') {
item.label = item.label + '(结束)';
item.type = 'default';
} else if (item.status === 'PAUSE') {
item.label = item.label + '(暂停)';
item.type = 'warn';
}
this.offerRoundList.push(item);
}
if (item.type === 'RATING') {
item.label = '第' + item.round + '轮评标';
if (item.status === 'GOING') {
item.label = item.label + '(进行中)';
item.type = 'primary';
} else if (item.status === 'NOT_STARTED') {
item.label = item.label + '(未开始)';
item.type = 'disabled';
} else if (item.status === 'FINISH') {
item.label = item.label + '(结束)';
item.type = 'default';
} else if (item.status === 'PAUSE') {
item.label = item.label + '(暂停)';
item.type = 'warn';
}
this.bidAssessList.push(item);
}
});
this.offerRoundList = listSort(this.offerRoundList, 'sortNumber');
this.bidAssessList = listSort(this.bidAssessList, 'sortNumber');
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
},
replaceRouter(str) {
this.$router.replace('/cargo/view/' + this.cargoId + str);
},
goRouter(str) {
this.$router.replace(str);
},
backSourceList() {
if (this.$store.state.device === 'wap') {
this.$router.go(-1);
} else {
document.location = "http://action:10002/?";
}

},


startStage() {
this.startShow = true;
},

sureStartStage() {
this.$post('api/sourcing/' + this.cargoId + '/start-stage', {}).then((data) => {
if (data.status === 'success') {
this.getSourceDetail();
this.$vux.toast.text('已开始本阶段');
} else {
this.$vux.toast.text(data.message);
}
})
},

endStage() {
this.endShow = true;
},

sureEndStage() {
this.$post('api/sourcing/' + this.cargoId + '/end-stage', {}).then((data) => {
if (data.status === 'success') {
this.getSourceDetail();
this.$vux.toast.text('已结束本阶段');
} else {
this.$vux.toast.text(data.message);
}
})
},

pauseStage() {
this.pauseShow = true;
},

surePauseStage() {
this.$post('api/sourcing/' + this.cargoId + '/pause-current-stage', {}).then((data) => {
this.getSourceDetail();
this.$vux.toast.text('已暂停本阶段');
})
},

beginStage() {
this.beginShow = true;
},

sureBeginStage() {
this.$post('api/sourcing/' + this.cargoId + '/continue-execution', {}).then((data) => {
this.getSourceDetail();
this.$vux.toast.text('已继续本阶段');
})
},

finishSource() {
this.finishShow = true;
},

sureFinishSource() {
this.$post('api/sourcing/' + this.cargoId + '/termination', {}).then((data) => {
if (data.status === 'success') {
this.getSourceDetail();
this.$vux.toast.text('已终止本项目');
} else {
this.$vux.toast.text(data.message);
}
});
},

operationShow() {
this.operationBol = true;
},
requiredValid(){
for (let i = 0; i < this.cargoItemDto.requireGoodsOrderDts.length; i++) {
let flag = false;
this.cargoItemDto.requireGoodsOrderDts[i].requireGoodsOrderDtRows.forEach(row => {
if (row.planType == 'confirm' && row.planCount) {
flag = true;
}
});
if (!flag) {
this.$vux.toast.text("物料: "+this.cargoItemDto.requireGoodsOrderDts[i].matName+"未填写要货数量！");
return false;
}
}
return true;
},
operationRelease(){
if (!this.cargoItemDto.requireGoodsOrderDts || this.cargoItemDto.requireGoodsOrderDts.length < 1) {
this.$vux.toast.text("未添加计划明细");
return;
}
let flag = this.requiredValid();
if (!flag) {
this.detailCollVisible = true;
return;
};
this.cargoItemDto.requireGoodsOrderDts.forEach(x => {
x.status = 'unConfirm';
x.requireGoodsOrderDtRows.forEach(y => {
y.status = 'unConfirm';
});
});
this.$loadingShow();
this.$put('api/requireGoodsOrder', this.cargoItemDto).then((res) => {

this.$vux.toast.text('发布成功');
this.backLastPage();

this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},
planConfirm(){
this.requireGoodsOrderDtsData = this.$refs.son.cargoDto.requireGoodsOrderDts.filter(item => {
return item.checked;
});
if(!this.requireGoodsOrderDtsData.length){
this.$vux.toast.text("请选择要确认的明细");
return;
}
let matName;
this.requireGoodsOrderDtsData.forEach(dt => {
dt.requireGoodsOrderDtRows.forEach(dto => {
if (dto.planType === 'confirm') {
if (dto.planCount != null && dto.confirmCount == null) {
matName = dt.purOrderDetail.materialName;
dto.confirmCount = dto.planCount;
}
}
});
});
if (matName) {
this.$vux.toast.text( '物料：' + matName + '的确认发货数量未填写完整！');
return;
};
this.$put('api/requireGoodsOrderDt/batchConfirm/'+this.cargoItemDto.id, this.requireGoodsOrderDtsData).then((res) => {

this.$vux.toast.text('确认成功');
this.backLastPage();

this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},
backLastPage() {
if (this.$store.state.device === 'wap') {
if (this.singleWorkflow) {
this.$router.replace('/');
} else {
this.$router.go(-1);
}
} else {
document.location = "http://action:10002/?";
}
},
operation(key, item) {
if (key !== 'cancel' && item) {
if (item.key === 'begin') {
this.startStage();
} else if (item.key === 'end') {
this.endStage();
} else if (item.key === 'paused') {
this.pauseStage();
} else if (item.key === 'continue') {
this.beginStage();
} else if (item.key === 'finish') {
this.finishSource();
}
}
},

offerRoundShow() {
this.offerRoundBol = true;
},
chooseOfferRound(key, item) {
if (key !== 'cancel' && item) {
if (item.status === 'NOT_STARTED') {
this.$vux.toast.text('该阶段还未开始');
return;
}
this.$get('api/souring-normal-quote/check-pur', {round: item.round, id: this.cargoId}).then((data) => {
if (data.status == 0) {
if (data.data) {
this.$router.replace('/source/view/' + this.cargoId + '/offer-overbid/' + item.round);
} else {
this.$router.replace('/source/view/' + this.cargoId + '/offer-view/' + item.round);
}
}
});

}
},

bidAssessShow() {
this.bidAssessBol = true;
},

chooseBidAssess(key, item) {
if (key !== 'cancel' && item) {
if (item.status === 'NOT_STARTED') {
this.$vux.toast.text('该阶段还未开始,不能进行评标');
}
if (item.status === 'PAUSE') {
this.$vux.toast.text('该阶段暂停中,不能进行评标');
}
if (item.status === 'GOING') {
this.$router.replace(`/source/view/${this.cargoId}/bid-assess/${item.id}`);
}
if (item.status === 'FINISH') {
this.$router.replace(`/source/view/${this.cargoId}/bid-assess/${item.id}`);
}
}
},

goAward() {
if (this.cargoItemDto.status === 'AWARD' || this.cargoItemDto.status === 'FINISH') {
this.$router.replace(`/source/view/${this.cargoId}/bid-win`);
} else {
this.$vux.toast.text('还未到达定价/决标');
}
},
sourceClick(e) {
if (e === 'NOT_STARTED') {
this.$vux.toast.text('该阶段还未开始');
return;
}
if (e == 'ENROLL') {
this.$router.replace('/audit-qual-list');
}
if (e == 'OFFER') {
this.$get('api/souring-normal-quote/check-pur', {
round: this.cargoItemDto.currentRound || 1,
id: this.cargoId
}).then((data) => {
if (data.status == 0) {
if (data.data) {
this.$router.replace('/source/view/' + this.cargoId + '/offer-overbid/' + this.cargoItemDto.currentRound);
} else {
this.$router.replace(`/source/view/${this.cargoId}/offer-view/${this.cargoItemDto.currentRound}/quotations-list`);
}
}
});
}
if (e == 'RATING') {
if (this.cargoItemDto.currentStage.status == "NOT_STARTED") {
this.$router.replace('/source/view/' + this.cargoId + '/bid-open');
} else {
this.goRouter(`/source/view/${this.cargoId}/offer-view/${this.cargoItemDto.currentRound || 1}/quotations-list`);
}
}
},
cancelApproval() {
this.operationBol = false;
}
},
mounted() {
this.cargoId = this.$route.params.id;
this.getSourceDetail();
this.userType = this.$store.state.userType
console.log(this.$store.state.userType, "登录", null == 0)
},
watch: {
'$route.path': function (newVal, oldVal) {
this.getSourceDetail();
}
}

}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/view/view.vue